// Hand-authored canonical lessons, keyed by language code → topic slug (the
// slugs match src/data/curricula.js). These are teacher-quality workbook lessons
// in the shape StudentLessonView renders — the Skill Tree uses one of these
// INSTEAD of asking the local model whenever a topic has one, so the shared
// lesson is deterministic, correct, offline, and never contains personal data.
//
// Lesson shape (all target-language text in `tr`, English in `en`):
// {
//   title, level, goal,
//   sections: [{
//     kind: 'concept' | 'vocab' | 'paradigm' | 'patterns' | 'practice',
//     title, note?,
//     table?: { columns: [..], rows: [[..], ..] },
//     words?: [{ tr, en }], sentences?: [{ tr, en }],
//     exercise?: { type: 'translate' | 'fill' | 'choose' | 'match', prompt, items: [{ q, a, options? }] },
//   }],
//   reading?: { title, text, glossary?: [{ tr, en }], questions?: [{ q, a }] },
//   dialogue?: { title, lines: [{ who, tr, en }] },
//   speaking?: [ 'prompt', .. ],
// }
import tur from './tur'

const lessons = { tur }

export const getBuiltinLesson = (code, slug) => (lessons[code] && lessons[code][slug]) || null
export const builtinSlugs = (code) => Object.keys(lessons[code] || {})

export default lessons
